module.exports = __webpack_public_path__ + "img/login_bg.621d24f0.png";